import { CustomerAppointmentDTO } from '../../api/api';
import { AppointmentErrors } from '../../models/CreationErrors';

const PHONE_NUMBER_PATTERN = /^\d{8}$/;

export const isValidPhoneNumber = (phoneNumber?: string) => PHONE_NUMBER_PATTERN.test(phoneNumber ?? '');

export const validateCustomerAppointmentContact = (customerAppointment?: CustomerAppointmentDTO): AppointmentErrors => {
  let errors: AppointmentErrors = {};

  if (!customerAppointment?.customerName?.trim()) errors.customerName = true;

  if (!isValidPhoneNumber(customerAppointment?.customerPhoneNumber)) errors.customerPhoneNumber = true;

  return errors;
};

export const getCustomerAppointmentErrorMessage = (errors: AppointmentErrors) => {
  const missingFields = [];

  if (errors.customerName) missingFields.push('Kontaktperson');
  if (errors.customerPhoneNumber) missingFields.push('Kontaktpersons tlf. nr. (8 cifre)');

  return `Mangler felter på Kundeaftale: ${missingFields.join(', ')}`;
};
